import React from 'react';
import { APP_VERSION } from '@/lib/version';

export function VersionBadge() {
    return (
        <div className="fixed top-2 right-2 z-40 pointer-events-none">
            <div className="text-[10px] text-muted-foreground/40 font-mono select-none">
                v{APP_VERSION}
            </div>
        </div>
    );
}

